import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    maxWidth: 396,
    margin: '5px auto',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(0, 1),
  },
  paymentModalInner: {
    textAlign: 'center',
    display: 'flex',
    flexFlow: 'column',
    rowGap: '1rem',
    padding: '1rem',
  },
  paymentModalBrandImg: {
    maxHeight: '40px',
  },
  paymentModalQr: {
    boxShadow: '0 2px 5px 1px rgba(64,60,67,.16)',
    display: 'inline-flex',
    margin: '0 auto', 
    padding: '1rem',
  }
}));

export default useStyles;
